import Auth from '@/utilities/auth'
import System from '..'
const signalR = require('@microsoft/signalr')

export class GStatusR{
    connection = null

    constructor(){
        this.Configure()
    }

    Configure(){
        if(Auth.user?.Id){
            this.Connect().then(()=> this.Listen())
        }
    }

    Connect(){
        return new Promise((resolve,reject)=>{
            this.connection = new signalR.HubConnectionBuilder().withUrl(System.BaseURL.URL + "/gstatushub",{ 
                headers:{ CompanyId : Auth.companyId || null },
                transport: signalR.HttpTransportType.LongPolling 
            }).build()
            this.connection.start().then(function(s){ 
                System.Development ? console.log('SignalR Connected For G Status') : null
                resolve() 
            }).catch(function (err) { reject(err) })
        })
    }

    Listen(){
        this.connection.on('updateGStatus', (c)=> { 
            debugger;
            System.GStatus = c === '1' ? true : false
        })
    }
}